import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

// Config for Redux-Persist
export const rootPersistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2,
    blacklist: [],
};

export const authPersistConfig = {
    key: 'auth',
    storage,
    stateReconciler: autoMergeLevel2,
    blacklist: ['error'],
};
